<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '@/utils/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
  tableClass?: HTMLAttributes['class']
  /**
   * When true, omit the inner overflow-auto wrapper so the parent supplies the scroll container.
   * Required for sticky thead + a sticky toolbar above the table (single vertical scroll).
   */
  noScrollContainer?: boolean
}>()
</script>

<template>
  <div
    v-if="!noScrollContainer"
    data-slot="table-container"
    :class="cn('relative w-full overflow-auto', props.class)"
  >
    <table
      data-slot="table"
      :class="cn('w-full caption-bottom text-sm border-collapse table-fixed', props.tableClass)"
    >
      <slot />
    </table>
  </div>
  <table
    v-else
    data-slot="table"
    :class="cn('relative w-full caption-bottom text-sm border-collapse table-fixed', props.tableClass, props.class)"
  >
    <slot />
  </table>
</template>
